module.exports = __webpack_public_path__ + "img/configuracoes.e8260235.png";